const config = {
    recipient: {
        types: {
            personal: 'personal',
            exchange: 'exchange',
        },
    },
};

export default config;